import axios from "@/utils/axiosHelper";

// 初始化数据(含授权)
export const onGetInitDataAPI = params => {
  return axios({ url: "/sword/mid/init", method: "GET", params }, { interceptResultCode: false });
};

// 制作订单
export const onMakeMoonCakeAPI = data => {
  return axios({ url: "/sword/mid/lottery", method: "POST", data });
};

// 兑换物品
export const onExchangeProductAPI = data => {
  return axios({ url: "/sword/mid/exchange", method: "POST", data });
};

// 帮助页面初始化
export const onGetHelpInitDataAPI = params => {
  return axios({ url: "/sword/mid/help", method: "GET", params }, { interceptResultCode: false });
};

// 帮助
export const onHelpAPI = data => {
  return axios({ url: "/sword/mid/help", method: "POST", data }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/hjwq/mid-autumn/api.js